import React from "react";

import styles from "./TableRow.module.css";

const TableRow = props => {
  return <tr className={styles.tr}>{props.children}</tr>
};

export default TableRow;